// @noflow
import styled, { keyframes } from 'styled-components';

import { getColour } from '~/core/utils/colour';
import PropTypes from 'prop-types';
import * as React from 'react';
import { textAnchor } from '../constants';

const fadeIn = keyframes`
	0% { opacity: 0; }
	100% { opacity: 1; }
`;

const SVGElem = styled.svg`
    animation: ${() => `${fadeIn} 0.25s linear`};
    height: ${({ height }) => `${height}px`};
    position: absolute;
    transition: transform 0.3s ease;
    transform: ${({ x, y }) => `translate3d(${x}px, ${y}px, 0)`};
    width: ${({ width }) => `${width}px`};
`;

const { MIDDLE } = textAnchor;
const defaultTextStyles = {
    fontFamily: 'Bariol, Arial',
    fontSize: '1em',
    fill: '#FFFFFF'
};
const circleRadius = 50;
const triangleHeight = 10;
const triangleHeightHalf = triangleHeight / 2;

export const initialValues = {
    backgroundColour: getColour(32),
    x: -(circleRadius * 2),
    xLabel: '',
    y: -(circleRadius * 2),
    yLabel: ''
};

const _getPolyPoints = () => {
    const x1 = circleRadius - triangleHeightHalf;
    const y1 = circleRadius * 2 - 1;
    const x2 = x1 + triangleHeight;
    const y2 = y1 + triangleHeight;
    const x3 = x1 + triangleHeightHalf;

    return [x1, y1, x2, y1, x3, y2, x1, y1].join(',');
};

const propTypes = {
    backgroundColour: PropTypes.string,
    textStyleX: PropTypes.shape({
        fontFamily: PropTypes.string,
        fontSize: PropTypes.string,
        fill: PropTypes.string
    }),
    textStyleY: PropTypes.shape({
        fontFamily: PropTypes.string,
        fontSize: PropTypes.string,
        fill: PropTypes.string
    }),
    x: PropTypes.number,
    xLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    y: PropTypes.number,
    yLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const GraphToolTip = ({
    backgroundColour = initialValues.backgroundColour,
    textStyleX = defaultTextStyles,
    textStyleY = {
        ...defaultTextStyles,
        fontSize: '1.6em'
    },
    x = initialValues.x,
    xLabel = initialValues.xLabel,
    y = initialValues.y,
    yLabel = initialValues.yLabel
}) => {
    const textStyleXCombined = { ...textStyleX, textAnchor: MIDDLE };
    const textStyleYCombined = { ...textStyleY, textAnchor: MIDDLE };
    const shapeStyle = { fill: backgroundColour };
    const svgX = x - circleRadius;
    const svgY = y - circleRadius * 2 - triangleHeight;
    const polyPoints = _getPolyPoints();
    const yTextY = circleRadius + 4;
    const xTextY = circleRadius + 25;
    const shouldRender = x !== initialValues.x && y !== initialValues.y;
    return (
        <div>
            {shouldRender && (
                <SVGElem
                    height={circleRadius * 2 + triangleHeight}
                    name="GraphToolTip"
                    width={circleRadius * 2}
                    x={svgX}
                    y={svgY}
                >
                    <polygon points={polyPoints} style={shapeStyle} />
                    <circle cx={circleRadius} cy={circleRadius} r={circleRadius} style={shapeStyle} />
                    <text style={textStyleYCombined} x={circleRadius} y={yTextY}>
                        {yLabel}
                    </text>
                    <text style={textStyleXCombined} x={circleRadius} y={xTextY}>
                        {xLabel}
                    </text>
                </SVGElem>
            )}
        </div>
    );
};

GraphToolTip.propTypes = propTypes;

export default GraphToolTip;



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph-tool-tip/index.js